// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Result from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryConfig from "../../../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PricingDashboardConfig from "../../../../library/utils/PricingDashboardConfig.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";
import * as PricingDashboardAssetsManager from "../../../../../assets/PricingDashboardAssetsManager.bs.js";

var info_icon = PricingDashboardAssetsManager.getImage("info-icon.svg");

var validators_price_per_km = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: param.price_per_km
                    }), (function (price) {
                    if (price < 0.0 || price > PricingDashboardConfig.slab_price_per_km_limit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Enter values between 0 and 100"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: price
                            };
                    }
                  }));
    })
};

var validators_price_per_min = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: param.price_per_min
                    }), (function (price) {
                    if (price < 0.0 || price > PricingDashboardConfig.slab_price_per_min_limit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Enter values between 0 and 25"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: price
                            };
                    }
                  }));
    })
};

var validators = {
  price_per_km: validators_price_per_km,
  price_per_min: validators_price_per_min
};

function initialFieldsStatuses(_input) {
  return {
          price_per_km: /* Pristine */0,
          price_per_min: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            price_per_km: /* Pristine */0,
            price_per_min: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.price_per_km;
  var match_0 = match ? match._0 : Curry._1(validators.price_per_km.validate, input);
  var match$1 = fieldsStatuses.price_per_min;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.price_per_min.validate, input);
  var price_per_kmResult = match_0;
  var price_per_kmResult$1;
  if (price_per_kmResult.TAG === /* Ok */0) {
    var price_per_minResult = match_0$1;
    if (price_per_minResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                price_per_min: price_per_minResult._0,
                price_per_km: price_per_kmResult._0
              },
              fieldsStatuses: {
                price_per_km: /* Dirty */{
                  _0: price_per_kmResult,
                  _1: /* Shown */0
                },
                price_per_min: /* Dirty */{
                  _0: price_per_minResult,
                  _1: /* Shown */0
                }
              },
              collectionsStatuses: undefined
            };
    }
    price_per_kmResult$1 = price_per_kmResult;
  } else {
    price_per_kmResult$1 = price_per_kmResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            price_per_km: /* Dirty */{
              _0: price_per_kmResult$1,
              _1: /* Shown */0
            },
            price_per_min: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurPrice_per_kmField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.price_per_km, validators_price_per_km, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  price_per_km: status,
                                  price_per_min: init.price_per_min
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurPrice_per_minField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.price_per_min, validators_price_per_min, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  price_per_km: init.price_per_km,
                                  price_per_min: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdatePrice_per_kmField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.price_per_km, state.submissionStatus, validators_price_per_km, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            price_per_km: status,
                                            price_per_min: init.price_per_min
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePrice_per_minField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.price_per_min, state.submissionStatus, validators_price_per_min, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            price_per_km: init.price_per_km,
                                            price_per_min: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                price_per_km: /* Pristine */0,
                                price_per_min: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                price_per_km: /* Pristine */0,
                                price_per_min: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updatePrice_per_km: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePrice_per_kmField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updatePrice_per_min: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePrice_per_minField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurPrice_per_km: (function (param) {
              return Curry._1(dispatch, /* BlurPrice_per_kmField */0);
            }),
          blurPrice_per_min: (function (param) {
              return Curry._1(dispatch, /* BlurPrice_per_minField */1);
            }),
          price_per_kmResult: Formality.exposeFieldResult(state.fieldsStatuses.price_per_km),
          price_per_minResult: Formality.exposeFieldResult(state.fieldsStatuses.price_per_min),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.price_per_km || match.price_per_min) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function LastSlabCmp(Props) {
  var start_distance = Props.start_distance;
  var price_per_min = Props.price_per_min;
  var price_per_km = Props.price_per_km;
  var isSubmitted = Props.isSubmitted;
  var onChange = Props.onChange;
  var form = useForm({
        price_per_min: price_per_min,
        price_per_km: price_per_km
      }, (function (param, param$1) {
          
        }));
  React.useEffect((function () {
          Curry._3(onChange, form.input.price_per_min, form.input.price_per_km, Curry._1(form.valid, undefined));
          
        }), [form.input]);
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  return React.createElement("div", {
              className: "slab " + (
                isSubmitted && !Curry._1(form.valid, undefined) ? "error-slab" : ""
              )
            }, React.createElement("div", {
                  className: "last-slab-warning"
                }, React.createElement("img", {
                      src: info_icon
                    }), React.createElement("b", undefined, "This slab is mandatory")), React.createElement(Row$Catalyst.make, {
                  children: React.createElement("div", {
                        className: "title"
                      }, "Last Slab"),
                  className: "slab-header"
                }), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Distance Range",
                      unit: "kms"
                    }), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (_event) {
                              
                            }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: start_distance
                      }
                    }), React.createElement("div", {
                      className: "label"
                    }, "to"), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (param) {
                              
                            }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: "∞"
                      }
                    })), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Price per KM",
                      unit: currency
                    }), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updatePrice_per_km, (function (input, value) {
                                            return {
                                                    price_per_min: input.price_per_min,
                                                    price_per_km: value
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.price_per_kmResult, undefined, undefined, undefined, {
                            TAG: /* Text */0,
                            _0: "Enter values between 0 and 100"
                          }, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.price_per_km
                      }
                    })), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Price per min",
                      unit: currency
                    }), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updatePrice_per_min, (function (input, value) {
                                            return {
                                                    price_per_min: value,
                                                    price_per_km: input.price_per_km
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.price_per_minResult, undefined, undefined, undefined, {
                            TAG: /* Text */0,
                            _0: "Enter values between 0 and 25"
                          }, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.price_per_min
                      }
                    })));
}

var make = LastSlabCmp;

export {
  info_icon ,
  Form ,
  make ,
  
}
/* info_icon Not a pure module */
